import script from "./CardPersonaReserva.vue?vue&type=script&setup=true&lang=js"
export * from "./CardPersonaReserva.vue?vue&type=script&setup=true&lang=js"

import "./CardPersonaReserva.vue?vue&type=style&index=0&id=f40b56bc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f40b56bc"]])

export default __exports__